export enum OperatorRole {
  admin = 100,
  operator = 108,
}

export enum LoginNameType {
  qq = 11,
  wx = 12,
}

export enum LoginType {
  qq = 1,
  wx = 2,
}

export interface LoginInfo {
  login_name: string;
  login_name_type: LoginNameType;
  login_type: LoginType;
}

export interface Operator {
  operator_id?: number;
  operator_name?: string;
  operator_role?: OperatorRole;
  mobile?: string;
  user_id?: number;
  logins?: LoginInfo;
  comment?: string;
}
